import {
  ArrowDownRight,
  ArrowUpRight,
  Clock,
  Cross,
} from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from '@/components/ui/item'
import {
  getAvoidanceLabel,
  getFrequencyLabel,
  getInjuryLabel,
  getLikelihoodLabel,
} from './risk-sets/riskAssessmentSetUtils'

export type RiskInFactorsGridProps = {
  injury: string | null
  frequency: string | null
  likelihood: string | null
  avoidance: string | null
  /** List layout uses 4 columns on md; card detail uses 2. */
  layout?: 'twoColumn' | 'fourColumn'
}

export function RiskInFactorsGrid({
  injury,
  frequency,
  likelihood,
  avoidance,
  layout = 'twoColumn',
}: RiskInFactorsGridProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const naLabel = t('hazardsPage.hazardDetail.na')
  const gridClassName =
    layout === 'fourColumn'
      ? 'grid gap-2 md:grid-cols-4'
      : 'grid gap-2 md:grid-cols-2'

  return (
    <div className={gridClassName}>
      <Item variant='outline' size='xs'>
        <ItemMedia variant='icon'>
          <Cross />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>{t('hazardsPage.injuryLabel')}</ItemTitle>
          <ItemDescription>
            {injury
              ? t(
                  `hazardsPage.enums.riskInjury.${injury}`,
                  getInjuryLabel(injury)
                )
              : naLabel}
          </ItemDescription>
        </ItemContent>
      </Item>
      <Item variant='outline' size='xs'>
        <ItemMedia variant='icon'>
          <Clock />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>{t('hazardsPage.frequencyLabel')}</ItemTitle>
          <ItemDescription>
            {frequency
              ? t(
                  `hazardsPage.enums.riskFrequency.${frequency}`,
                  getFrequencyLabel(frequency)
                )
              : naLabel}
          </ItemDescription>
        </ItemContent>
      </Item>
      <Item variant='outline' size='xs'>
        <ItemMedia variant='icon'>
          <ArrowUpRight />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>{t('hazardsPage.likelihoodLabel')}</ItemTitle>
          <ItemDescription>
            {likelihood
              ? t(
                  `hazardsPage.enums.riskLikelihood.${likelihood}`,
                  getLikelihoodLabel(likelihood)
                )
              : naLabel}
          </ItemDescription>
        </ItemContent>
      </Item>
      <Item variant='outline' size='xs'>
        <ItemMedia variant='icon'>
          <ArrowDownRight />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>{t('hazardsPage.avoidanceLabel')}</ItemTitle>
          <ItemDescription>
            {avoidance
              ? t(
                  `hazardsPage.enums.riskAvoidance.${avoidance}`,
                  getAvoidanceLabel(avoidance)
                )
              : naLabel}
          </ItemDescription>
        </ItemContent>
      </Item>
    </div>
  )
}
